import ApiServer from "../ApiServer.js";
import FizConfig from "../FizConfig.js";
import deviceId from "../lib/deviceId.js";
import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as progressbar from "../util/progressbar.ts";
import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as ga from "../tracking-googleanalytics.js";
import * as Storage from "../lib/Storage.ts";

const KEY = "firstPageWantedAfterLogin";

let 
  page = libLocation.getPageName(),
  url = libLocation.getLocation();
if(page==='settings.php'){
  Storage.sessionSet(KEY,url);

}else{
  Storage.sessionRemove(KEY);
}

function handleAfterLogin(){
  if(Storage.sessionGet(KEY)!==null){
    libLocation.goTo(Storage.sessionGet(KEY));
    Storage.sessionRemove(KEY);
    return true;
  }
  return false;
}

var theStore = {
    get:function(){
      var 
        rememberIdentifier = Storage.localGet("rememberIdentifier"),
        rememberToken = Storage.localGet("rememberToken");
      return {rememberIdentifier,rememberToken}
    },
    store:function(rememberIdentifier,rememberToken){
      Storage.localSet("rememberIdentifier",rememberIdentifier);
      Storage.localSet("rememberToken",rememberToken);
    },
    clear:function(){
      Storage.localRemove("rememberIdentifier")
      Storage.localRemove("rememberToken")
    }
}


function backHome(){
  theStore.clear();
  if(Storage.sessionGet(KEY)!==null){
    libLocation.goTo('fw2_signin.php');
  }else{
    window.location = 'index.html?noautologin';
  }  
} 

function autoLogin(needToNotify){
  var
    {rememberIdentifier,rememberToken} = theStore.get(),
    familyId = FwDatas.getLastFamilyId();
  
  function doautologin(){
    if(navigator.cookieEnabled===true){
      var apis = [ApiServer.log2loginByAutologinToken.prepare(rememberIdentifier, rememberToken)];
      
      if(familyId !==undefined){
        apis.push(ApiServer.famlogfamily.prepare(familyId));
      }
      ApiServer.group(apis)({}, function(loginResp){
        window.analytics?.identify(loginResp.accountId);
        libLocation.refresh()
      }, backHome);
    }else{
      backHome();
    }
    
  }
  
  if ( rememberIdentifier && rememberToken && (rememberIdentifier+rememberToken).length>0){
    if(needToNotify){
      modal.ask({
        title:"global.sessionendedtitle",
        message:"global.sessionended",
        button:[
          {class:'secondary',title:'actions.yes',onclick:doautologin},
          {class:'negative',title:'actions.no',onclick:backHome},
          ]
        });
    }else{
      doautologin();
    }
  }else{
    backHome();
  }
  return false;
}

function loginsuccess(log2inresponse){
  ga.event({
    'event': 'login',
    'form_name': 'signin form'
  }) 
  window.analytics?.identify(log2inresponse.accountId);
  if(log2inresponse.genericAutologinToken && (Storage.localGet("rememberme")==='true')){
    
  //FIXME improve identifier getting because it looks hasardous
    var identifier = $("[name=a00identifier]").val();
    
    theStore.store(identifier,log2inresponse.genericAutologinToken);
    
  }else{
    theStore.clear();
  }
}
ApiServer.log2in = ApiServer.log2in.prepare(loginsuccess);

//logout handling
amplify.subscribe("sessionExpired",function(data){
  //if we autologged less than 10 seconds ago it is not an issue of cookie acceptance
  if(data.fromApi && navigator.cookieEnabled===false){
    i18n.loadLanguage()
    modal.alert("You must accept cookies for url "+FizConfig.API_BASE_URL,backHome);
    progressbar.standard.close();
    
  }else{
    FwDatas.reset();
    Storage.sessionSet('isLoggued','false');
    autoLogin(data.fromWebsocket);
  }
});

function logoutWantedByUser(){
  function afterLogout(){
    // Delete cookies for "Remember me" login
    theStore.clear();
    
    amplify.publish("sessionExpired",{fromUser:true});
  }
  
  if(deviceId){
    ApiServer.devicedelete(deviceId);
  }
  ApiServer.log2out(afterLogout,afterLogout);
}
Html.register({
  logout:logoutWantedByUser,
  termsaccept:function(){
    ApiServer.accsetterms(true,function(){
      libLocation.goTo(INR.URL.ENTER_HOME);
    })
  },
  termsdecline:function(){
    import("../modal/termsdecline.mustache").then(TPL_TERMS_DECLINE=>modal.openModal(TPL_TERMS_DECLINE,{}));
  }
});
  
export {
  logoutWantedByUser,
  handleAfterLogin
};